<template>
  <!-- car -->
  <q-img
    class="car-img"
    :src="底盘透明_纵向_不带轮胎"
    :style="{
      height: IMG_HEIGHT + 'px',
      width: IMG_WIDTH + 'px',
    }"
    spinner-color="white"
    fit="contain"
  >
    <!-- 轮胎 -->
    <q-img
      v-for="(tire, index) in tires"
      :key="tire.name"
      :style="{
        position: 'absolute',
        left: tire.position.left + 'px',
        top: tire.position.top + 'px',
        right: tire.position.right + 'px',
        bottom: tire.position.bottom + 'px',
        width: TIRES_WIDTH + 'px',
        height: TIRES_HEIGHT + 'px',
        transform: 'rotate(' + -datas[index].angle + 'deg)',
        opacity: opacitys2[index] || 0,
      }"
      :src="tire.src"
      alt="tire"
    >
    </q-img>
    <!-- 轮的蒙版 -->
    <div
      v-for="(tire, index) in tires"
      :key="tire.name"
      :style="{
        position: 'absolute',
        left: tire.position.left + 'px',
        top: tire.position.top + 'px',
        right: tire.position.right + 'px',
        bottom: tire.position.bottom + 'px',
        width: TIRES_WIDTH + 'px',
        height: TIRES_HEIGHT + 'px',
        transform: 'rotate(' + -datas[index].angle + 'deg)',
        opacity: opacitys[index] || 0,
        zIndex: 2,
      }"
      style="border-radius: 8px; background-color: #ff6f00"
    ></div>

    <!-- DUR -->
    <div
      class="column justify-center items-center absolute text-weight-bolder text-subtitle1"
      :style="{
        top: 0 + 'px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#ff0000',
      }"
    >
      <img
        class="q-mb-sm"
        :src="showDURWarnFlag ? DUR_ICON_RED : DUR_ICON_GARY"
        style="width: 40px"
        alt="DUR"
        @click="showDURWarnFlag && (showDURWarnText = !showDURWarnText)"
      />
      <div v-show="showDURWarnText" class="text-float">动平衡异常</div>
    </div>
    <!-- speed -->

    <div
      class=""
      :style="{
        position: 'absolute',
        right: tires[0].position.right + 'px',
        left: -((tires[0].position.left || 0) + 86) + 'px',
        top: tires[0].position.top + 'px',
        bottom: tires[0].position.bottom + 'px',
      }"
    >
      <Statistic
        key="1"
        name="车辆行驶速度"
        :value="(props.notifyData.UIRx_VehSpd || 0).toFixed(1)"
        units-of-measurement="kph"
        icon=" "
        :width="150"
        style="font-size: 14px"
      ></Statistic>
    </div>

    <div
      class="text-weight-bolder text-subtitle1"
      :style="{
        position: 'absolute',
        right: -((tires[1].position.right || 0) + 60) + 'px',
        left: tires[1].position.left + 'px',
        top: tires[1].position.top + 'px',
        bottom: tires[1].position.bottom + 'px',
      }"
    >
      <Statistic
        name="前轴转角"
        :value="(datas[1].angle || 0).toFixed(1)"
        units-of-measurement="°"
        icon=""
        :width="110"
        style="font-size: 14px"
      ></Statistic>
      <!-- <div>{{ `前轴转角 ${datas[1].angle}°` }}</div> -->
    </div>
    <div
      class="text-weight-bolder text-subtitle1"
      :style="{
        position: 'absolute',
        right: -((tires[2].position.right || 0) + 60) + 'px',
        left: tires[2].position.left + 'px',
        top: tires[2].position.top + 'px',
        bottom: (tires[2].position.bottom || 0) + 10 + 'px',
      }"
    >
      <Statistic
        name="后轴转角"
        :value="
          domainControlStore.outputValueParsed.UITx_ActuatorEna_Rws === 0
            ? 0
            : (datas[2].angle || 0).toFixed(1)
        "
        units-of-measurement="°"
        icon=""
        :width="110"
        style="font-size: 14px"
      ></Statistic>
      <!-- <div>{{ `后轴转角 ${datas[2].angle}°` }}</div> -->
    </div>

    <!-- <div
      :class="`absolute text-weight-bolder text-subtitle1 ${
        props.notifyData.UIRx_MassEstiMod === 2 ? 'text-green' : 'text-grey'
      }`"
      :style="{
        position: 'absolute',
        right: tires[3].position.right + 'px',
        left: -((tires[3].position.left || 0) + 60) + 'px',
        top: tires[3].position.top + 'px',
        bottom: (tires[3].position.bottom || 0) + 10 + 'px',
      }"
      @click="emit('resetVLM')"
    >
      <Statistic
        name="车辆估计重量"
        :value="props.notifyData.UIRx_VehMass || 0"
        units-of-measurement="kg"
        icon=" "
        :width="100"
        style="font-size: 14px; color: black"
      ></Statistic>
    </div> -->
  </q-img>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import 轮胎左 from "@/assets/img/轮胎左.png";
import 底盘透明_纵向_不带轮胎 from "@/assets/img/底盘透明_纵向_不带轮胎.png";
import 轮胎右 from "@/assets/img/轮胎右.png";
import DUR_ICON_RED from "@/assets/img/DUR_ICON_RED.png";
import DUR_ICON_GARY from "@/assets/img/DUR_ICON_GARY.png";
import Statistic from "./Statistic";
import { useDomainControlStore } from "@/stores/domainControl";

const domainControlStore = useDomainControlStore();

const emit = defineEmits(["resetVLM"]);

interface Props {
  datas: { name: string; value: number; angle: number }[];
  notifyData: DomianControl.IVSENotifyData;
}
const props = withDefaults(defineProps<Props>(), {
  datas: () => [
    { name: "左前", value: 0, angle: 0 },
    { name: "右前", value: 0, angle: 0 },
    { name: "右后", value: 0, angle: 0 },
    { name: "左后", value: 0, angle: 0 },
  ],
  notifyData: () => ({} as DomianControl.IVSENotifyData),
});

const IMG_HEIGHT = 600;
const CAR_HEIGHT = 1810;
const IMG_RATE = IMG_HEIGHT / CAR_HEIGHT;
const IMG_WIDTH = 813 * IMG_RATE;
const TIRES_TOP = 245 * IMG_RATE;
const TIRES_BOTTOM = 367 * IMG_RATE;
const TIRES_HEIGHT = 250* IMG_RATE;
const TIRES_WIDTH = 96 * IMG_RATE;
const TIRES_RIGHT = 76 * IMG_RATE;
const TIRES_LEFT = 90 * IMG_RATE;
const showDURWarnText = ref(false);
const showDURWarnFlag = ref(false); // 开关拨杆
// 透明度
const opacitys = computed(() => {
  return props.datas.map((data) => {
    return (data.value / 50).toFixed(2);
  });
});
const opacitys2 = computed(() => {
  const opacitys = props.datas.map((data) => {
    const value = data.value > 50 ? 50 : data.value;
    return 1 - Number((value / 50).toFixed(2));
  });
  return opacitys;
});

const tires = ref([
  {
    name: "左前",
    // value: 0,
    error: false,
    src: 轮胎左, // 轮胎图片路径
    position: { left: TIRES_LEFT, top: TIRES_TOP }, // 轮胎在车图片中的位置
    gaugePosition: { left: -80, top: -50 },
    gaugeLabelPosition: "left",
  },
  {
    name: "右前",
    // value: 0,
    error: false,
    src: 轮胎右,
    position: { right: TIRES_RIGHT, top: TIRES_TOP },
    gaugePosition: { right: 0, top: -50 },
    gaugeLabelPosition: "right",
  },
  {
    name: "右后",
    // value: 0,
    error: false,
    src: 轮胎右,
    position: { right: TIRES_LEFT, bottom: TIRES_BOTTOM },
    gaugePosition: { right: 0, bottom: 100 },
    gaugeLabelPosition: "right",
  },
  {
    name: "左后",
    // value: 0,
    error: false,
    src: 轮胎左,
    position: { left: TIRES_RIGHT, bottom: TIRES_BOTTOM },
    size: { width: 50, height: 50 },
    gaugePosition: { left: -80, bottom: 100 },
    gaugeLabelPosition: "left",
  },
]);

watch(
  props.datas,
  (value) => {
    // 0-50 超过 50，显示报警   从 50 以上往后走 40 以下，关闭报警
    const max = Math.max(...value.map((item) => item.value));
    if (!showDURWarnFlag.value) {
      // showDURWarnFlag 同时也作为拨杆
      if (max >= 50) {
        showDURWarnFlag.value = true;
      }
    } else {
      if (max < 40) {
        showDURWarnFlag.value = false;
      }
    }
  },
  { deep: true }
);

watch(showDURWarnFlag, (value) => {
  if (!value) showDURWarnText.value = false;
});
</script>

<style scoped lang="scss">
.car-img {
  .q-img__content > div {
    background-color: transparent;
    padding: 0px;
  }
}
.q-img {
  overflow: unset;
}

.text-float {
  font-weight: 700;
  font-size: 18px;
  padding: 5px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
